import React, { useEffect, useState } from "react";
import PublicLayout from "../components/PublicLayout";
import api from "../lib/api";

export default function CommonNumber() {
  const [c, setC] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get("/commons/latest")
      .then((r) => setC(r.data && r.data.id ? r.data : null))
      .catch(() => setC(null))
      .finally(() => setLoading(false));
  }, []);

  const Row = ({ direct, house, ending }) => (
    <table className="nt-table my-3">
      <thead>
        <tr>
          <th>Direct</th>
          <th>House</th>
          <th>Ending</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>{direct || "-"}</td>
          <td>{house || "-"}</td>
          <td>{ending || "-"}</td>
        </tr>
      </tbody>
    </table>
  );

  return (
    <PublicLayout title="Lucky Teer">
      <div className="nt-container mt-6">
        <div className="text-center font-display text-xl mb-2" data-testid="common-date">
          {c?.date || "—"}
        </div>
        <div className="border rounded-lg overflow-hidden">
          <div className="bg-slate-100 text-center py-2 font-extrabold border-b">
            Lucky Teer
          </div>
          {loading ? (
            <div className="p-6 text-center text-slate-500">Loading...</div>
          ) : c ? (
            <div className="p-3">
              <Row direct={c.direct1} house={c.house1} ending={c.ending1} />
              <Row direct={c.direct2} house={c.house2} ending={c.ending2} />
              {c.text ? (
                <p
                  className="text-center text-sm text-slate-700 mt-2"
                  data-testid="common-text"
                >
                  {c.text}
                </p>
              ) : null}
            </div>
          ) : (
            <div className="p-6 text-center text-slate-500">
              No common number published yet.
            </div>
          )}
        </div>

        <div className="mt-6 bg-yellow-50 border-l-4 border-yellow-500 rounded-md p-4">
          <p className="text-sm text-slate-800 font-semibold">
            <strong>Disclaimer:</strong> These common numbers are purely based on certain
            calculations done using past results. There is no guarantee of the accuracy
            of these numbers.
          </p>
        </div>
      </div>
    </PublicLayout>
  );
}
